import { render, staticRenderFns } from "./historialActualizacion.vue?vue&type=template&id=c9675cca"
import script from "./historialActualizacion.vue?vue&type=script&lang=js"
export * from "./historialActualizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports